function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as l } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: e , size: r = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = l(), i = e !== null && e !== void 0 ? e : a ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ o("path", {
            fill: i,
            d: "M9.571 21.81c-.563 0-.874-.314-.874-.88v-4.773a.3.3 0 01.01-.074 5.513 5.513 0 01-2.057-1.172l-3.992 4.123a.28.28 0 11-.4-.39l3.995-4.13a5.522 5.522 0 012.444-8.976V3.057c0-.55.32-.866.871-.868h.686c1.211-.001 3.631-.003 5.824 0a.278.278 0 01.2.08l5.461 5.463a.277.277 0 01.081.199v13.028c0 .54-.31.851-.848.851h-11.4zm.776-5.48c-.373 0-.737-.037-1.09-.107v4.707c0 .258.062.32.317.32h11.398c.224 0 .288-.068.291-.292V8.21H18.81c-.88 0-1.633-.289-2.179-.832-.546-.543-.832-1.297-.832-2.18v-2.45h-6.23c-.24 0-.31.07-.31.308v2.34a5.52 5.52 0 016.61 5.414 5.53 5.53 0 01-1.616 3.904 5.502 5.502 0 01-3.905 1.616zm10.518-8.68l-4.507-4.505V5.2c0 1.487.961 2.45 2.451 2.45h2.056zM5.386 10.81a4.961 4.961 0 109.923-.001 4.961 4.961 0 00-9.923 0z"
        })
    }));
}, m = s;
export { m as default };
